var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.18,
    height: 20.5,
    viewBox: "0 0 18.18 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9492",
    "data-name": "Path 9492",
    d: "M12,12A5,5,0,1,0,7,7,5,5,0,0,0,12,12Z",
    transform: "translate(-2.91 -2)",
    fill: "#f3903a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9493",
    "data-name": "Path 9493",
    d: "M12,14.5c-5.01,0-9.09,3.36-9.09,7.5a.5.5,0,0,0,.5.5H20.59a.5.5,0,0,0,.5-.5C21.09,17.86,17.01,14.5,12,14.5Z",
    transform: "translate(-2.91 -2)",
    fill: "#f3903a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e16bc3f70779699ef211e456bae49bf8.svg";
export { ForwardRef as ReactComponent };